import {fetchAndDeserialize, serializeToURLParameters} from '../../../util/api-adapter';
import {PaginationDataType} from '../../../util/pagination-hook/pagination-hook-type';
import {objectToUrlParameters} from '../../../util/url';
import {PaginatedResponseType} from '../../api/api-type';

import {
    AspectsAnalysisRequestParametersType,
    AspectsAnalysisTableRequestParametersType,
    reviewAspectRecordSchema,
    ReviewAspectRecordType,
    reviewAspectsToneDistributionSchema,
    ReviewAspectsToneDistributionType,
    reviewAspectsToneDynamicsSchema,
    ReviewAspectsToneType,
    reviewsCountByAspectsSchema,
    ReviewsCountByAspectsType,
    topAspectsItemSchema,
    TopAspectsItemType,
    TopAspectsQueryParametersType,
} from './review-aspects-type';

export function fetchReviewsAnalysisAspects(
    requestOptions: AspectsAnalysisTableRequestParametersType & PaginationDataType
): Promise<PaginatedResponseType<ReviewAspectRecordType>> {
    const {filterKey, sortQueryValue, page, pageSize, ...restRequestOptions} = requestOptions;

    return fetchAndDeserialize(
        `/v2/reviews-analytics/stats/aspects/?${objectToUrlParameters({
            ...serializeToURLParameters(restRequestOptions),
            ...serializeToURLParameters({page, pageSize}),
            filter_key: filterKey,
            sort: sortQueryValue,
        })}`,
        reviewAspectRecordSchema
    );
}

export function fetchReviewsAnalysisAspectsTone(
    requestOptions: AspectsAnalysisRequestParametersType
): Promise<ReviewAspectsToneType> {
    const {filterKey, ...restRequestOptions} = requestOptions;

    return fetchAndDeserialize(
        `/v2/reviews-analytics/stats/aspects-tonality-dynamics/?${objectToUrlParameters({
            ...serializeToURLParameters(restRequestOptions),
            filter_key: filterKey,
        })}`,
        reviewAspectsToneDynamicsSchema
    );
}

export function fetchReviewsAnalysisAspectsToneDistribution(
    requestOptions: AspectsAnalysisRequestParametersType
): Promise<ReviewAspectsToneDistributionType> {
    const {filterKey, ...restRequestOptions} = requestOptions;

    return fetchAndDeserialize(
        `/v2/reviews-analytics/stats/aspects-tonality-distribution/?${objectToUrlParameters({
            ...serializeToURLParameters(restRequestOptions),
            filter_key: filterKey,
        })}`,
        reviewAspectsToneDistributionSchema
    );
}

export function fetchReviewsCountByAspects(
    requestOptions: AspectsAnalysisRequestParametersType
): Promise<ReviewsCountByAspectsType> {
    const {filterKey, ...restRequestOptions} = requestOptions;

    return fetchAndDeserialize(
        `/v2/reviews-analytics/stats/reviews-by-aspects/?${objectToUrlParameters({
            ...serializeToURLParameters(restRequestOptions),
            filter_key: filterKey,
        })}`,
        reviewsCountByAspectsSchema
    );
}

export async function fetchTopAspects(
    mainFilterKey: string,
    filterParameters: TopAspectsQueryParametersType
): Promise<Array<TopAspectsItemType>> {
    const url = `/v2/reviews-analytics/stats/top-aspects/?${objectToUrlParameters({
        filter_key: mainFilterKey,
        start_date: filterParameters.startDate,
        end_date: filterParameters.endDate,
        able_to_reply: filterParameters.ableToReply,
    })}`;

    return fetchAndDeserialize<Array<TopAspectsItemType>>(url, topAspectsItemSchema.array());
}
